import flow from 'lodash/fp/flow';
import {
  sanitizeSortsForBackwardsCompatibility,
  sanitizeFiltersForBackwardsCompatibility,
  sanitizeLocation,
  sanitizeOccupants,
  sanitizeDaysToCheckIn,
  sanitizeStayDates,
  sanitizeSortOptions,
  sanitizePayWith,
  sanitizePriceFilters,
  sanitizeClassicRewards,
} from './sanitizers';

import { omitEmpty } from 'lib/object';

export const sanitizeSearch = flow([
  sanitizeSortsForBackwardsCompatibility,
  sanitizeFiltersForBackwardsCompatibility,
  sanitizeLocation,
  sanitizeOccupants,
  sanitizeDaysToCheckIn,
  sanitizeStayDates,
  sanitizeSortOptions,
  sanitizePayWith,
  sanitizePriceFilters,
  sanitizeClassicRewards,
  omitEmpty,
]);
